import axios from "axios";
import { useContext, useEffect, useState } from "react";
import { Container, Spinner } from "react-bootstrap";
import "../../../assets/css/user/shops/shop.css";
import AppContext from "../../../context/AppContext";
import Footer from "../footer/Footer";
import SimpleBanner from "../general/SimpleBanner";
import Navbar from "../navbar/Navbar";
import TPshop from "../tpshop/Tpshop";
import MarqueeBanner from "../Marqueebanner/Marqueebanner";
import MyNavbar from "../navbar/Navbar";

export default function BrowseShops() {
  const { baseUrl } = useContext(AppContext);
  const [shops, setShops] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [visibleShops, setVisibleShops] = useState(4);

  const filtered = shops.filter(
    (shop) =>
      shop.shopname?.toLowerCase().includes(search.toLowerCase()) ||
      shop.businessCategory?.toLowerCase().includes(search.toLowerCase()) ||
      shop.shopaddress?.toLowerCase().includes(search.toLowerCase()),
  );
  const fetchAllShops = () => {
    setLoading(true);
    const formData = new FormData();
    formData.append("limit", 4);

    axios
      .post(`${baseUrl}/customer/shop/fetchAllShops`, formData, {
        headers: { "Content-Type": "multipart/formData" },
      })
      .then((res) => {
        console.log("Shops Response:", res.data);

        if (res.data.success === true) {
          setShops(res.data.shops);
        }

        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };
  useEffect(() => {
    fetchAllShops();
  }, []);

  return (
    <>
      <MarqueeBanner />
      <MyNavbar />

      <SimpleBanner
        title="Brower Shops"
        subtitle="Discover verified sellers and their deals"
        breadcrumbs={[
          { label: "Home", href: "/" },
          { label: "browershop", href: "/shop" },
        ]}
      />
      <Container fluid>
        <div className="browse-wrapper">
          <div className="search-bar">
            <svg
              className="search-icon"
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <circle cx="11" cy="11" r="8" />
              <line x1="21" y1="21" x2="16.65" y2="16.65" />
            </svg>
            <input
              type="text"
              placeholder="Search shops..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="search-input"
            />
          </div>

          {loading ? (
            <div className="text-center py-5">
              <Spinner animation="border" />
            </div>
          ) : (
            <>
              <div className="shops-grid">
                {filtered.slice(0, visibleShops).map((shop) => (
                  <TPshop key={shop.id} shop={shop} />
                ))}

                {filtered.length === 0 && (
                  <p className="no-results">No shops found.</p>
                )}
              </div>

              {visibleShops < filtered.length && (
                <div className="text-center mt-4">
                  <button
                    className="blog-view-all"
                    onClick={() => setVisibleShops((prev) => prev + 4)}
                  >
                    Load More
                  </button>
                </div>
              )}
            </>
          )}
        </div>
      </Container>
      <Footer />
    </>
  );
}
